import React from "react";

export default function SampleReports() {
  return (
    <div className="page-body">
    </div>
  );
}

